import { v4 as uuidv4 } from "uuid";
export class AutomationDetailsModel {
    constructor() {
        this.id = uuidv4();
        this.title = "";
        this.recurrenceRule = "";
        this.savedSearch = "";
        this.organizationId = "";
        this.savedSearchId = "";
    }
}
export default class AutomationDetails extends AutomationDetailsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
